import React from "react";
import "./Partnerskap.css";
import Partnerskapimg from "../../assets/ttgimage2.jpg";

const Partnerskap = () => {
  return (
    <div className="box-2-taktillgolv-main-info">
      <div className="taktillgolv-image-container-right-1-3-custom">
        <img src={Partnerskapimg} alt="Square Image" />
      </div>
      <div className="taktillgolv-text-container-3-custom">
        <div className="taktillgolv-title-3-custom">
          Ditt Partnerskap för Bygg och Renovering
        </div>

        <div className="taktillgolv-text-3-custom1">
          Tak Till Golv är inte bara ett byggföretag – vi är er pålitliga
          partner för att förverkliga era projekt. Med en mångsidig expertis
          inom totalentreprenad och renovering erbjuder vi skräddarsydda
          lösningar för alla era behov. Vår mångsidiga erfarenhet sträcker sig
          från att lägga solida grundstenar till att förvandla varje yta till en
          konstnärlig mästerverk.
          <br></br>
          <br></br>
          Vi är specialister på att lyssna på era önskemål och omvandla dem till
          praktiska, hållbara resultat. Från tak till golv, från målning till
          tapetsering, och från el- till VVS-jobb – vi har kunskapen och
          expertisen för att hantera alla aspekter av ert projekt. Med vår
          dedikerade personal vid rodret kan ni vara säkra på att ert projekt
          kommer att utföras med precision och professionalism, varje steg på
          vägen.
          <br></br>
          <br></br>
          Med Tak Till Golv vid er sida kan ni känna er trygga med att ert
          projekt kommer att slutföras på bästa möjliga sätt, i tid och inom
          budget. Vi är redo att ta er vision och göra den till verklighet – låt
          oss hjälpa er att skapa något extraordinärt, tillsammans.
        </div>
      </div>
    </div>
  );
};

export default Partnerskap;
